import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class CiscoAmp extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <circle cx="15.577" cy="12" r="3.044" />
        <path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0ZM1,11.155A10.958,10.958,0,0,1,2.127,7.069l6.305,4Zm7.436,1.78-6.305,4A10.958,10.958,0,0,1,1,12.845Zm7.94,9.2V17.651a.795.795,0,0,0-1.59,0v5.034A11.04,11.04,0,0,1,2.6,17.78l6.995-3.366-2.853,4.27,4.5-4.132a5.02,5.02,0,0,1,0-5.1l-4.5-4.132,2.853,4.27L2.6,6.22a11.04,11.04,0,0,1,12.183-4.9V6.4a.8.8,0,1,0,1.59,0V1.865a11.059,11.059,0,0,1,6.636,9.34H21.146a.8.8,0,1,0,0,1.59h1.862A11.059,11.059,0,0,1,16.372,22.135Z" />
      </svg>
    );
  }
}

export default CiscoAmp;
